import { Check, X } from 'lucide-react';
import { siteData } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

export const FitSection = () => {
  const { fit } = siteData;
  const [ref, isInView] = useInView();

  return (
    <section id="who-its-for" className="py-[90px] lg:py-[110px] bg-white">
      <div
        ref={ref}
        className={`max-w-[1200px] mx-auto px-6 lg:px-8 ${
          isInView ? 'animate-fade-in-up' : 'opacity-0'
        }`}
      >
        <h2 className="font-heading text-[1.85rem] lg:text-[2.5rem] font-bold text-stone-900 leading-[1.15] max-w-[520px] tracking-[-0.01em]">
          {fit.headline}
        </h2>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
          {/* Good fit */}
          <div className="p-7 rounded-2xl bg-[#edf5f2] border border-[#2d6a5a]/8">
            <h3 className="font-heading text-[0.95rem] font-semibold text-stone-900 mb-5">
              {fit.goodFit.title}
            </h3>
            <div className="space-y-3.5">
              {fit.goodFit.items.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="mt-0.5 w-5 h-5 rounded-full bg-[#2d6a5a]/15 flex items-center justify-center flex-shrink-0">
                    <Check size={11} className="text-[#2d6a5a]" />
                  </div>
                  <span className="text-stone-600 text-[0.88rem] leading-relaxed">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Not ideal */}
          <div className="p-7 rounded-2xl bg-stone-50 border border-stone-200/40">
            <h3 className="font-heading text-[0.95rem] font-semibold text-stone-900 mb-5">
              {fit.notIdeal.title}
            </h3>
            <div className="space-y-3.5">
              {fit.notIdeal.items.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="mt-0.5 w-5 h-5 rounded-full bg-stone-200/80 flex items-center justify-center flex-shrink-0">
                    <X size={11} className="text-stone-400" />
                  </div>
                  <span className="text-stone-400 text-[0.88rem] leading-relaxed">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <p className="mt-9 text-[0.95rem] text-stone-500 max-w-[580px] leading-[1.7]">
          {fit.closing}
        </p>
      </div>
    </section>
  );
};
